import { createSelector } from 'reselect';
import type { RootState } from '../../configuration/setup/store';
import { VehicleType } from './vehicleProfileTypes';

export const selectVehicleProfile = (state: RootState) => state.vehicleProfile;
export const selectIsEV = createSelector(selectVehicleProfile, state => state.isEV);
export const selectIsSelectedVehicleEv = createSelector(
    selectVehicleProfile,
    state => state.assetLocked?.details?.details_bev
);
export const selectDefaultEvProfile = createSelector(selectVehicleProfile, state => state.defaultEvProfile);
export const selectIsProfileSubmited = createSelector(selectVehicleProfile, state => state.isProfileSubmited);
export const selectOutdoorTemperature = createSelector(
    selectVehicleProfile,
    state => state.averageOutdoorTemperature.value
);
export const selectVehiclePayload = createSelector(selectVehicleProfile, state => state.vehiclePayload.value);
export const selectVehicleAxlesField = createSelector(selectVehicleProfile, state => state.vehicleAxles);
export const selectTrailerAxlesField = createSelector(selectVehicleProfile, state => state.trailerAxles);
export const selectWeightPerAxleField = createSelector(selectVehicleProfile, state => state.weightPerAxle);
export const selectWeightPerAxleGroupField = createSelector(selectVehicleProfile, state => state.weightPerAxleGroup);
export const selectEmissionClassification = createSelector(
    selectVehicleProfile,
    state => state.emissionClassification.value
);
export const selectHazardClassification = createSelector(
    selectVehicleProfile,
    state => state.hazardClassification.value
);
export const selectProfilePlugTypes = createSelector(selectVehicleProfile, state => state.profilePlugTypes);
export const selectProfileType = createSelector(selectVehicleProfile, state => state.profileType.value);
export const selectProfileTypeField = createSelector(selectVehicleProfile, state => state.profileType);
export const selectTruckTypeField = createSelector(selectVehicleProfile, state => state.truckType);
export const selectTrailerField = createSelector(selectVehicleProfile, state => state.trailer);
export const selectTunnelCategory = createSelector(selectVehicleProfile, state => state.tunnelCategory.value);
export const selectBatteryCapacity = createSelector(selectVehicleProfile, state => state.batteryCapacity);
export const selectBatteryPacks = createSelector(selectVehicleProfile, state => state.batteryPacks.value);
export const selectLengthField = createSelector(selectVehicleProfile, state => state.length);
export const selectHeightField = createSelector(selectVehicleProfile, state => state.height);
export const selectWidthField = createSelector(selectVehicleProfile, state => state.width);
export const selectTotalWeightField = createSelector(selectVehicleProfile, state => state.totalWeight);
export const selectEmptyWeightField = createSelector(selectVehicleProfile, state => state.emptyWeight);
export const selectCargoWeightField = createSelector(selectVehicleProfile, state => state.cargoWeight);
export const selectPlugTypeField = createSelector(selectVehicleProfile, state => state.plugType);
export const selectPayloadWeightField = createSelector(selectVehicleProfile, state => state.payloadWeight);
export const selectHasValidBooking = createSelector(
    selectVehicleProfile,
    state => state.currentBookingState === undefined || state.currentBookingState === 'ACTIVE'
);
export const selectIsCustomProfile = createSelector(
    selectProfileType,
    state => state === VehicleType.CUSTOM_EV || state === VehicleType.CUSTOM_ICE
);
export const selectDeviceId = createSelector(selectVehicleProfile, state => state.deviceId.value);
export const selectAssetChargePortTypes = createSelector(
    selectVehicleProfile,
    state => state.assetLocked?.batteryConfiguration?.chargePortType ?? []
);

export const selectAssetTemperature = createSelector(selectVehicleProfile, state => state.assetLocked?.temperature);

export const selectMaxCargoWeightField = createSelector(selectVehicleProfile, state => state.maxCargoWeight);
export const selectMaxFreightTrainWeightField = createSelector(
    selectVehicleProfile,
    state => state.maxFreightTrainWeight
);

export const selectMaxCargoWeightInKg = createSelector(
    selectMaxFreightTrainWeightField,
    selectEmptyWeightField,
    (maxFreightTrainWeight, emptyWeight) =>
        maxFreightTrainWeight.value !== undefined && emptyWeight.value !== undefined
            ? maxFreightTrainWeight.value * 1000 - emptyWeight.value
            : undefined
);

export const selectHasCargoExceededMax = createSelector(
    selectCargoWeightField,
    selectMaxCargoWeightInKg,
    (cargoWeight, maxCargoWeightInKg) =>
        maxCargoWeightInKg !== undefined && (cargoWeight.value ?? 0) > maxCargoWeightInKg
);
